import * as React from 'react'
import {Lang} from 'yougile-lang'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {
  getValue,
  SelectWithCheckboxes,
  SelectWithCheckboxProps
} from '@components/common/base/select-with-dropdown/select-with-checkboxes'
import {menuItemHeight} from './constants'

export interface SelectedColumnsProps {
  onChange?: (props: OptionsItemCheckbox[]) => void
  columns: OptionsItemCheckbox[]
  onlyOne?: boolean
  getCaption?: SelectWithCheckboxProps['getCaption']
  disabled?: boolean
}

export const SelectedColumns = (props: SelectedColumnsProps) => {
  const {columns = [], onlyOne, getCaption, disabled} = props

  const onChange = (data: OptionsItemCheckbox[]) => {
    props.onChange?.([...data])
  }
  const placeholder = onlyOne
    ? Lang.msg.movementTemplates.destinationSelectColumnPlaceholder
    : Lang.msg.movementTemplates.destinationSelectColumnsPlaceholder

  const value = (getCaption || getValue)(columns, undefined, placeholder)

  return (
    <SelectWithCheckboxes
      options={columns}
      value={value}
      placeholder={placeholder}
      size={menuItemHeight}
      allCaption={onlyOne ? '' : Lang.msg.all}
      disabled={disabled || !columns?.length}
      onChange={onChange}
      onlyOne={onlyOne}
      getCaption={getCaption}
    />
  )
}
